class CartRemoveButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (event) => {
      event.preventDefault()
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
      const freeSampleEl = cartItems.parentElement.querySelector('free-sample')
      if (freeSampleEl) {
        const freeSampleCount = freeSampleEl.dataset.samplesInCart

        if (this.dataset.isFreeSample == 'true') {
          const sampleCheckbox = freeSampleEl.querySelector(`input[data-variant-id="${this.dataset.variantId}"]`)
          freeSampleEl.removeSampleFromCart({ target: sampleCheckbox })
        } else {
          const cartItemCount = cartItems.querySelectorAll('.cart-item')?.length
          if (cartItemCount - 1 === parseInt(freeSampleCount, 10)) return cartItems.clearCart()
          else {
            cartItems.updateQuantity(this.dataset.index, 0)
          }
        }
      } else {
        cartItems.updateQuantity(this.dataset.index, 0)
      }
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super()
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus')

    const debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)

    this.addEventListener('change', debouncedOnChange.bind(this))
  }

  cartUpdateUnsubscriber = undefined

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return
      }
      this.onCartUpdate()
    })
  }

  clearCart() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    fetch(`${routes.cart_clear_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)

        this.classList.toggle('is-empty', parsedState.item_count === 0)

        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        })
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('!hidden'))
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber()
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
    if (event.target.value === '9') {
      this.updateLiveRegions(event.target.dataset.index, 'You have added the maximum qty!')
    }
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const sourceQty = html.querySelector('cart-items')
        this.innerHTML = sourceQty.innerHTML
      })
      .catch((e) => {
        console.error(e)
      })
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ]
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`)
        const items = document.querySelectorAll('.cart-item')

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value')
          this.updateLiveRegions(line, parsedState.errors)
          return
        }

        const $cartDrawer = document.querySelector('cart-drawer')

        const html = new DOMParser().parseFromString(state, 'text/html')
        const cartTotal = html.querySelector('[data-total-price').dataset
        const splitPrice = cartTotal.totalPrice.split('"')[1]
        const finalPrice = parseInt(splitPrice.replace(/\\/g, ''))

        const siteWideSaleTierOneDiscount = parseInt($cartDrawer.dataset.siteWideSaleTierOneDiscount)
        const siteWideSaleTierTwoThreshold = parseInt($cartDrawer.dataset.siteWideSaleTierTwoThreshold)

        if (siteWideSaleTierOneDiscount > 0) {
          document.querySelectorAll('[data-site-wide-sale-tier-one]').forEach(($siteWideSaleTierOne) => {
            const $priceWrapper = $siteWideSaleTierOne.closest('[id^="price-"]')
            const $siteWideSaleTierTwo = $priceWrapper.querySelector('[data-site-wide-sale-tier-two]')

            const isASiteWideDiscountTierPriceVisible =
              $siteWideSaleTierOne.style.display !== 'none' || $siteWideSaleTierTwo.style.display !== 'none'

            if (!isASiteWideDiscountTierPriceVisible) return

            if (finalPrice >= siteWideSaleTierTwoThreshold) {
              $siteWideSaleTierOne.style.display = 'none'
              $siteWideSaleTierOne.removeAttribute('selected')
              $siteWideSaleTierTwo.style.display = 'inline-block'
              $siteWideSaleTierTwo.setAttribute('selected', true)
            } else {
              $siteWideSaleTierTwo.style.display = 'none'
              $siteWideSaleTierTwo.removeAttribute('selected')
              $siteWideSaleTierOne.style.display = 'inline-block'
              $siteWideSaleTierOne.setAttribute('selected', true)
            }
          })
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0)
        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        })
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined
        let message = ''
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue)
          }
        }
        const cartDrawer = document.querySelector('cart-drawer')
        if (cartDrawer && cartDrawer.initializeFreeSampleSlider) {
          cartDrawer.initializeFreeSampleSlider()
        }
        this.updateLiveRegions(line, message)
        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`)
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus()
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' })
      })
      .catch((err) => {
        console.error(err)
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('!hidden'))
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        this.disableLoading(line)
        const totalDiv = document.querySelector('.totals__subtotal-value').innerText

        const freeSample = document.querySelector('[data-is-free-sample]')
        if (!freeSample) return

        const removeGiftButton = freeSample.querySelector('.cart-remove-button')
        if (!removeGiftButton) return
        const total = parseInt(totalDiv.slice(1, totalDiv.length - 1)) * 100
        const threshold = parseInt(document.querySelector('[data-gwp-threshold]')?.dataset?.gwpThreshold || '0')
        if (total === 0) {
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
          cartItems.clearCart()
        }
        if (total < threshold) {
          removeGiftButton.click()
        }
      })
  }

  initializeFreeSampleSlider() {
    const freeSampleSplide = this.querySelector('.splide.splide-free-samples')

    if (freeSampleSplide && typeof Splide !== 'undefined') {
      // Destroy existing instance if it exists
      if (freeSampleSplide.splide) {
        freeSampleSplide.splide.destroy()
      }

      const slider = new Splide(freeSampleSplide, {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '1rem',
        pagination: false,
        arrows: false,
      }).mount()

      if (typeof SplideHorizontalScroll !== 'undefined') {
        SplideHorizontalScroll(slider)
      }
    }
  }
  updateLiveRegions(line, message) {
    if (message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`)
      const lineItemErrorMessage = lineItemError.querySelector('.cart-item__error-text')
      if (lineItemErrorMessage.textContent !== message) {
        lineItemErrorMessage.textContent = message
        lineItemError.classList.remove('!hidden')
      } else {
        lineItemError.classList.add('!hidden')
      }
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`)
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`)

    ;[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('!hidden'))

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.remove('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`)
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`)

    cartItemElements.forEach((overlay) => overlay.classList.add('!hidden'))
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('!hidden'))
  }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super()

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value })
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            })
          }, ON_CHANGE_DEBOUNCE_TIMER)
        )
      }
    }
  )
}

class FreeSample extends HTMLElement {
  constructor() {
    super()

    this.maxSamples = parseInt(this.dataset.maxSamples, 10)
    this.addButtons = this.querySelectorAll('.free-sample__add-button')

    // Add click event listener for the new button
    this.addEventListener('click', (event) => {
      const { target } = event
      if (target.classList.contains('free-sample__add-button')) {
        const checkbox = target.closest('.product-form').querySelector('input[type="checkbox"]')
        if (checkbox) {
          if (checkbox.checked || this.dataset.samplesInCart >= this.maxSamples) {
            return
          } else {
            checkbox.checked = true
            this.addProductToCart(event)
          }
        }
      }
    })
  }
  addProductToCart(event) {
    event.preventDefault()

    const { target } = event
    const productForm = target.closest('product-form')?.querySelector('form')
    this.handleErrorMessage()

    this.querySelector('.loading-overlay__spinner')?.classList.remove('!hidden')

    const config = fetchConfig('javascript')

    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
    const formData = new FormData(productForm)
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      )
      formData.append('sections_url', window.location.pathname)
      cart.setActiveElement(document.activeElement)
    }
    config.body = formData
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        this.handleErrorMessage(response.description)

        if (!cart) window.location = window.routes.cart_url

        this.error = false

        const quickAddModal = this.closest('quick-add-modal')

        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response)
              })
            },
            { once: true }
          )
          quickAddModal.hide(true)
        } else {
          cart.renderContents(response)
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
        this.querySelector('.loading-overlay__spinner')?.classList.add('!hidden')
      })
  }

  removeSampleFromCart({ target }) {
    const cartItems =
      this.parentElement.querySelector('cart-items') || this.parentElement.querySelector('cart-drawer-items')
    cartItems.updateQuantity(target.dataset.index, 0)
    this.removeAttribute('checked')
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
    if (!this.errorMessageWrapper) return
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage
    }
  }
}

customElements.define('free-sample', FreeSample)
